import { ImportProspectSkippedIssue } from '@zaplify/prospects';

export const initialValues = {
    organizationFilter: {
        keywords: [],
        industries: [],
        organizations: [],
        organizationSizes: [],
    },
    personalFilter: {
        keywords: [],
        locations: [],
        occupationTitles: [],
        occupationFunctions: [],
        occupationSeniorities: [],
        yearsOfExperience: [{ min: 1, max: 20 }],
    },
    prospectLimit: 1,
    excludeInOrganization: true,
};

export const initialValues2 = {
    name: 'string',
    organizationFilter: {
        industries: [],
        organizations: [],
        organizationSizes: [],
    },
    personalFilter: {
        keywords: [],
        locations: [],
        occupationTitles: [],
        occupationFunctions: [],
        occupationSeniorities: [],
        yearsInCompany: [],
        yearsInCurrentRole: [],
    },
    prospectLimit: 100,
    excludeInOrganization: true,
};
export const industries = [
    'accounting',
    'airlines/aviation',
    'alternative dispute resolution',
    'alternative medicine',
    'animation',
    'apparel & fashion',
    'architecture & planning',
    'arts and crafts',
    'automotive',
    'aviation & aerospace',
    'banking',
    'biotechnology',
    'broadcast media',
    'building materials',
    'business supplies and equipment',
    'capital markets',
    'chemicals',
    'civic & social organization',
    'civil engineering',
    'commercial real estate',
    'computer & network security',
    'computer games',
    'computer hardware',
    'computer networking',
    'computer software',
    'construction',
    'consumer electronics',
    'consumer goods',
    'consumer services',
    'cosmetics',
    'dairy',
    'defense & space',
    'design',
    'e-learning',
    'education management',
    'electrical/electronic manufacturing',
    'entertainment',
    'environmental services',
    'events services',
    'executive office',
    'facilities services',
    'farming',
    'financial services',
    'fine art',
    'fishery',
    'food & beverages',
    'food production',
    'fund-raising',
    'furniture',
    'gambling & casinos',
    'glass, ceramics & concrete',
    'government administration',
    'government relations',
    'graphic design',
    'health, wellness and fitness',
    'higher education',
    'hospital & health care',
    'hospitality',
    'human resources',
    'import and export',
    'individual & family services',
    'industrial automation',
    'information services',
    'information technology and services',
    'insurance',
    'international affairs',
    'international trade and development',
    'internet',
    'investment banking',
    'investment management',
    'judiciary',
    'law enforcement',
    'law practice',
    'legal services',
    'legislative office',
    'leisure, travel & tourism',
    'libraries',
    'logistics and supply chain',
    'luxury goods & jewelry',
    'machinery',
    'management consulting',
    'maritime',
    'market research',
    'marketing and advertising',
    'mechanical or industrial engineering',
    'media production',
    'medical devices',
    'medical practice',
    'mental health care',
    'military',
    'mining & metals',
    'motion pictures and film',
    'museums and institutions',
    'music',
    'nanotechnology',
    'newspapers',
    'non-profit organization management',
    'oil & energy',
    'online media',
    'outsourcing/offshoring',
    'package/freight delivery',
    'packaging and containers',
    'paper & forest products',
    'performing arts',
    'pharmaceuticals',
    'philanthropy',
    'photography',
    'plastics',
    'political organization',
    'primary/secondary education',
    'printing',
    'professional training & coaching',
    'program development',
    'public policy',
    'public relations and communications',
    'public safety',
    'publishing',
    'railroad manufacture',
    'ranching',
    'real estate',
    'recreational facilities and services',
    'religious institutions',
    'renewables & environment',
    'research',
    'restaurants',
    'retail',
    'security and investigations',
    'semiconductors',
    'shipbuilding',
    'sporting goods',
    'sports',
    'staffing and recruiting',
    'supermarkets',
    'telecommunications',
    'textiles',
    'think tanks',
    'tobacco',
    'translation and localization',
    'transportation/trucking/railroad',
    'utilities',
    'venture capital & private equity',
    'veterinary',
    'warehousing',
    'wholesale',
    'wine and spirits',
    'wireless',
    'writing and editing',
];

export const companySizes = ['1-10', '11-50', '51-200', '201-500', '501-1000', '1001-5000', '5001-10000', '10001+'];

export const titleRoles = [
    'customer_service',
    'design',
    'education',
    'engineering',
    'finance',
    'health',
    'human_resources',
    'legal',
    'marketing',
    'media',
    'operations',
    'public_relations',
    'real_estate',
    'sales',
    'trades',
];

export const experienceTitleLevels = [
    'owner',
    'partner',
    'cxo',
    'vp',
    'director',
    'manager',
    'senior',
    'entry',
    'training',
    'unpaid',
];

export const titleSubRoles = [
    'accounting',
    'accounts',
    'brand_marketing',
    'broadcasting',
    'business_development',
    'compensation',
    'content_marketing',
    'customer_success',
    'data',
    'dental',
    'devops',
    'doctor',
    'editorial',
    'education_administration',
    'electrical',
    'employee_development',
    'events',
    'fitness',
    'graphic_design',
    'information_technology',
    'investment',
    'journalism',
    'judicial',
    'lawyer',
    'logistics',
    'mechanical',
    'media_relations',
    'network',
    'nursing',
    'office_management',
    'paralegal',
    'pipeline',
    'product',
    'product_design',
    'product_marketing',
    'professor',
    'project_engineering',
    'project_management',
    'property_management',
    'quality_assurance',
    'realtor',
    'recruiting',
    'researcher',
    'security',
    'software',
    'support',
    'systems',
    'tax',
    'teacher',
    'therapy',
    'video',
    'web',
    'web_design',
    'wellness',
    'writing',
];

export enum Count {
    ASSIGNED = 'assigned',
    AVAILABLE = 'available',
    BLOCK_LISTED = 'blocklisted',
    TOTAL = 'total',
}

export enum TransactionState {
    BOUGHT = 'bought',
    AVAILABLE = 'available',
}

export const ImportProspectSkippedIssueMapping: { [K in keyof typeof ImportProspectSkippedIssue]: string } = {
    [ImportProspectSkippedIssue.BLOCKLISTED]: 'Blocklisted',
    [ImportProspectSkippedIssue.DUPLICATE]: 'Duplicate in file',
    [ImportProspectSkippedIssue.EXISTS_IN_CRM]: 'Exists in CRM',
    [ImportProspectSkippedIssue.EXISTS_IN_ORGANIZATION]: 'Exists in organization',
};
